/**
 * Navigation configuration for the dashboard
 */

import {
  HomeIcon,
  EnvelopeIcon,
  Cog6ToothIcon,
  BuildingOfficeIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';

export interface NavigationItem {
  name: string;
  href: string;
  icon: ComponentType<{ className?: string }>;
  badge?: string | number;
  shortcut?: string;
}

export interface NavigationSection {
  title?: string;
  items: NavigationItem[];
}

export const mainNavigation: NavigationSection = {
  items: [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: HomeIcon,
    },
    {
      name: 'Submissions',
      href: '/submissions',
      icon: EnvelopeIcon,
    },
  ],
};

export const settingsNavigation: NavigationSection = {
  title: 'Settings',
  items: [
    {
      name: 'Workspaces',
      href: '/workspaces',
      icon: BuildingOfficeIcon,
    },
    {
      name: 'Preferences',
      href: '/settings',
      icon: Cog6ToothIcon,
    },
  ],
};

export const allNavigationSections = [mainNavigation, settingsNavigation];
